const ForgetPassword = () => import('@/views/ForgetPassword')

export default [
  {
    path: '/forgetPassword',
    component: ForgetPassword
  }
]
